<table
  mat-table
  [dataSource]="input.tableData | parse: context | async"
  multiTemplateDataRows
>
  @for (colDef of columnDefs$ | async; track index; let index = $index) {
    @let header = colDef.header;
    @let column = colDef.column;
    <ng-container matColumnDef="{{ $index }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngClass]="input.columnStyleClasses?.[index] | parse: context | async"
      >
        @if (isString(header) || isExpression(header)) {
          {{ header | parse: context | async }}
        } @else {
          <ng-container [dynamicWidget]="$any(header)" [context]="context" />
        }
      </th>
      <td mat-cell *matCellDef="let data">
        @if (isString(column)) {
          {{ data[column] }}
        } @else {
          <ng-container
            [dynamicWidget]="$any(column)"
            [context]="
              context | attach: data : input?.tableDataAlias || 'expansionRow'
            "
          />
        }
      </td>
    </ng-container>
  }
  <ng-container matColumnDef="expand" stickyEnd>
    <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
    <td mat-cell *matCellDef="let element">
      <button
        mat-icon-button
        (click)="toggle(element); $event.stopPropagation()"
        class="toggle-button"
        [class.expanded]="isExpanded(element)"
      >
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
  <ng-container matColumnDef="expandedDetail">
    <td
      mat-cell
      *matCellDef="let data"
      [attr.colspan]="(columnsToDisplay$ | async).length"
    >
      <div class="detail-wrapper">
        <div class="detail-container">
          @defer (when isExpanded(data)) {
            @for (widget of input?.widgets; track widget) {
              <ng-container
                [dynamicWidget]="widget"
                [context]="
                  context
                    | attach: data : input?.tableDataAlias || 'expansionRow'
                "
              />
            }
          }
        </div>
      </div>
    </td>
  </ng-container>

  <tr
    mat-header-row
    *matHeaderRowDef="columnsToDisplay$ | async; sticky: true"
  ></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: columnsToDisplay$ | async"
    class="element-row"
    [class.expanded]="isExpanded(element)"
    (click)="toggle(element)"
  ></tr>
  <tr
    mat-row
    *matRowDef="let data; columns: ['expandedDetail']"
    class="detail-row"
    [class.expanded]="isExpanded(data)"
  ></tr>
</table>
